/* eslint-disable compat/compat */
import { FareCode } from "@silversea-ssc/web-fares";
import { graphql, useStaticQuery } from "gatsby";
import { useCallback } from "react";
import { isPresent } from "src/utils/checks";
import { StaticFareNamesQuery } from "types/graphql-types";

type FareLabels = Record<FareCode, string>;

export const useStaticFareLabels = () => {
  const results = useStaticQuery<StaticFareNamesQuery>(graphql`
    query StaticFareNames {
      fares: allSanityFarePage(
        filter: { metadata: { routing: { path: { en: { ne: null } } } } }
      ) {
        nodes {
          fareCodes
          fareCode
          name: card {
            title {
              en
            }
          }
        }
      }
    }
  `);

  const fares = results.fares.nodes.reduce((acc, fare) => {
    const allCodes = Array.from(
      new Set([...(fare?.fareCodes || []), fare.fareCode])
    ).filter((x): x is FareCode => isPresent(x));

    const partial = Object.fromEntries(
      allCodes
        .map((code) => [code, fare.name?.title?.en])
        .filter(
          (x): x is [FareCode, string] => isPresent(x[0]) && isPresent(x[1])
        )
    ) as FareLabels;

    return {
      ...acc,
      ...partial
    };
  }, {} as FareLabels);

  const fareCodeLabel = useCallback(
    (fareCode: FareCode) => fares[fareCode] || fareCode,
    [fares]
  );
  return {
    fareCodeLabels: fares,
    fareCodeLabel
  };
};
